/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreatePartnerRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { PagedPartnerResponse } from '../models';
// @ts-ignore
import type { PartnerResponse } from '../models';
// @ts-ignore
import type { PartnerStatus } from '../models';
// @ts-ignore
import type { UpdatePartnerRequest } from '../models';
/**
 * PartnersApi - axios parameter creator
 * @export
 */
export const PartnersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a Partner
         * @summary Create a new partner
         * @param {CreatePartnerRequest} createPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerV1: async (createPartnerRequest: CreatePartnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPartnerRequest' is not null or undefined
            assertParamExists('createPartnerV1', 'createPartnerRequest', createPartnerRequest)
            const localVarPath = `/api/v1/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPartnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Partner
         * @summary Get partner by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerV1: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPartnerV1', 'id', id)
            const localVarPath = `/api/v1/partners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Partners
         * @summary List partners
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {PartnerStatus} [status] 
         * @param {string} [sort] 
         * @param {ListPartnersV1DirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnersV1: async (page?: number, size?: number, status?: PartnerStatus, sort?: string, direction?: ListPartnersV1DirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Partner details
         * @summary Update partner
         * @param {string} id 
         * @param {UpdatePartnerRequest} updatePartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerV1: async (id: string, updatePartnerRequest: UpdatePartnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePartnerV1', 'id', id)
            // verify required parameter 'updatePartnerRequest' is not null or undefined
            assertParamExists('updatePartnerV1', 'updatePartnerRequest', updatePartnerRequest)
            const localVarPath = `/api/v1/partners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePartnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnersApi - functional programming interface
 * @export
 */
export const PartnersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnersApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a Partner
         * @summary Create a new partner
         * @param {CreatePartnerRequest} createPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPartnerV1(createPartnerRequest: CreatePartnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPartnerV1(createPartnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnersApi.createPartnerV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Partner
         * @summary Get partner by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerV1(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerV1(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnersApi.getPartnerV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List Partners
         * @summary List partners
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {PartnerStatus} [status] 
         * @param {string} [sort] 
         * @param {ListPartnersV1DirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPartnersV1(page?: number, size?: number, status?: PartnerStatus, sort?: string, direction?: ListPartnersV1DirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedPartnerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPartnersV1(page, size, status, sort, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnersApi.listPartnersV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a Partner details
         * @summary Update partner
         * @param {string} id 
         * @param {UpdatePartnerRequest} updatePartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePartnerV1(id: string, updatePartnerRequest: UpdatePartnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePartnerV1(id, updatePartnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnersApi.updatePartnerV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PartnersApi - factory interface
 * @export
 */
export const PartnersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnersApiFp(configuration)
    return {
        /**
         * Create a Partner
         * @summary Create a new partner
         * @param {CreatePartnerRequest} createPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerV1(createPartnerRequest: CreatePartnerRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerResponse> {
            return localVarFp.createPartnerV1(createPartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Partner
         * @summary Get partner by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerV1(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PartnerResponse> {
            return localVarFp.getPartnerV1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * List Partners
         * @summary List partners
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {PartnerStatus} [status] 
         * @param {string} [sort] 
         * @param {ListPartnersV1DirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnersV1(page?: number, size?: number, status?: PartnerStatus, sort?: string, direction?: ListPartnersV1DirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<PagedPartnerResponse> {
            return localVarFp.listPartnersV1(page, size, status, sort, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a Partner details
         * @summary Update partner
         * @param {string} id 
         * @param {UpdatePartnerRequest} updatePartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerV1(id: string, updatePartnerRequest: UpdatePartnerRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerResponse> {
            return localVarFp.updatePartnerV1(id, updatePartnerRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnersApi - object-oriented interface
 * @export
 * @class PartnersApi
 * @extends {BaseAPI}
 */
export class PartnersApi extends BaseAPI {
    /**
     * Create a Partner
     * @summary Create a new partner
     * @param {CreatePartnerRequest} createPartnerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public createPartnerV1(createPartnerRequest: CreatePartnerRequest, options?: RawAxiosRequestConfig) {
        return PartnersApiFp(this.configuration).createPartnerV1(createPartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Partner
     * @summary Get partner by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public getPartnerV1(id: string, options?: RawAxiosRequestConfig) {
        return PartnersApiFp(this.configuration).getPartnerV1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Partners
     * @summary List partners
     * @param {number} [page] The zero-based index of the page of results to return.
     * @param {number} [size] The maximum number of results to return in a page.
     * @param {PartnerStatus} [status] 
     * @param {string} [sort] 
     * @param {ListPartnersV1DirectionEnum} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public listPartnersV1(page?: number, size?: number, status?: PartnerStatus, sort?: string, direction?: ListPartnersV1DirectionEnum, options?: RawAxiosRequestConfig) {
        return PartnersApiFp(this.configuration).listPartnersV1(page, size, status, sort, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a Partner details
     * @summary Update partner
     * @param {string} id 
     * @param {UpdatePartnerRequest} updatePartnerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    public updatePartnerV1(id: string, updatePartnerRequest: UpdatePartnerRequest, options?: RawAxiosRequestConfig) {
        return PartnersApiFp(this.configuration).updatePartnerV1(id, updatePartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListPartnersV1DirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type ListPartnersV1DirectionEnum = typeof ListPartnersV1DirectionEnum[keyof typeof ListPartnersV1DirectionEnum];
